import { z } from 'zod';

const dateLike = z.string().or(z.date());

export const BreachSeverityAssessmentSchema = z.object({
    dataSensitivity: z.number().int().min(1).max(4).optional(),
    identifiability: z.number().int().min(1).max(4).optional(),
    circumstances: z.number().int().min(0).max(4).optional(),
    score: z.number().optional(),
    level: z.enum(['low', 'medium', 'high', 'very_high']).optional(),
    subjectNotificationRequired: z.boolean().optional(),
});

export const DataBreachSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1),
    description: z.string().optional(),

    occurredAt: dateLike.optional(),
    detectedAt: dateLike.optional(),
    becameAwareAt: dateLike.optional(),
    detectedBy: z.string().nullish(),

    authorityDeadline: dateLike.optional(),
    dataSubjectDeadline: dateLike.optional(),
    lateNotificationJustification: z.string().optional(),

    affectedDataCategories: z.array(z.string()).optional(),
    affectedDataSubjectCount: z.number().int().optional(),
    affectedRecordCount: z.number().int().optional(),
    affectedDataSubjectTypes: z.array(z.string()).optional(),
    possibleConsequences: z.string().optional(),

    confidentialityImpact: z.boolean().optional(),
    integrityImpact: z.boolean().optional(),
    availabilityImpact: z.boolean().optional(),

    breachCause: z.string().optional(),
    breachType: z.enum(['unauthorized_access', 'theft', 'loss', 'disclosure', 'alteration', 'destruction']).optional(),

    processorOriginated: z.boolean().optional(),
    processorName: z.string().optional(),

    severityAssessment: BreachSeverityAssessmentSchema.optional(),
    incidentId: z.string().nullish(),

    notifiedToAuthority: z.boolean().optional(),
    authorityNotificationDate: dateLike.optional(),
    authorityNotificationRef: z.string().optional(),

    notifiedToDataSubjects: z.boolean().optional(),
    dataSubjectNotificationDate: dateLike.optional(),
    dataSubjectNotificationMethod: z.string().optional(),

    containmentMeasures: z.string().optional(),
    remediationMeasures: z.string().optional(),
    preventiveMeasures: z.string().optional(),

    assignee: z.string().nullish(),
    status: z.enum(['detected', 'investigating', 'contained', 'notified', 'closed']).optional(),
    severity: z.enum(['critical', 'high', 'medium', 'low']).optional(),
    customFields: z.record(z.unknown()).optional(),

    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateDataBreachSchema = DataBreachSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateDataBreachSchema = DataBreachSchema.partial();
